import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Icon } from "@components/Icon";
import { media } from "@themes/breakpoints";
import { theme } from "@themes/themes";

const LOCAL_STORAGE_KEY = "betaBannerClosed";

export const BetaVersion = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const closed = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!closed) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(LOCAL_STORAGE_KEY, "true");
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <BetaVersionContainer>
      <Message>
        {t("beta.message")}{" "}
        <a href="https://discord.com/invite/37682NeRb3" rel="noreferrer" target="_blank">
          {t("beta.shareFeedback")} <Icon color="accent-9" icon="ri-arrow-right-up-line" size="12" />
        </a>
      </Message>
      <CloseButton aria-label={t("common.close", "Close")} onClick={handleClose} type="button">
        <CloseIcon color="accent-contrast" icon="ri-close-large-line" size="16" />
      </CloseButton>
    </BetaVersionContainer>
  );
};

const BetaVersionContainer = styled(Flex)`
  position: relative;
  width: 100%;
  background: ${theme.color("green-weak")};
  color: ${theme.color("gray-5")};
  font-size: 14px;
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 8px 16px;

  ${media.mobile} {
    height: auto;
    align-items: center;
    justify-content: flex-start;
  }
`;

const Message = styled.div`
  ${theme.font.body12};
  text-align: center;
  color: ${theme.color("accent-contrast")};
  flex: 1;

  a {
    position: relative;
    text-decoration: none;
    color: ${theme.color("accent-9")};

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background: ${theme.color("accent-9")};
    }
  }

  ${media.mobile} {
    text-align: left;
  }
`;

const CloseIcon = styled(Icon)`
  cursor: pointer;
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
